module.exports = __webpack_public_path__ + "static/accs-2e1edb52934ccef8905f3cd1c8813185.jpg";